import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

function HomePage() {
  const [, setCountry] = useState('');
  const [region, setRegion] = useState('');
  const [city, setCity] = useState('');
  const [timeLeft, setTimeLeft] = useState(10 * 60);
  const [isLoaded, setIsLoaded] = useState(false);

  // Fetch the user's location
  useEffect(() => {
    fetch('/api/location')
      .then(response => response.json())
      .then(data => {
        const decodedCity = decodeURIComponent(data.city.replace(/\+/g, ' '));
  
        if (decodedCity === "unknown") {
          fetch('https://freeipapi.com/api/json/')
            .then(response => response.json())
            .then(externalData => {
              const externalDecodedCity = decodeURIComponent(externalData.cityName.replace(/\+/g, ' '));
              setCountry(externalData.countryCode);
              setCity(externalDecodedCity);
              setIsLoaded(true);
            })
            .catch(error => {
              console.error('Fetch error on external API:', error);
              setIsLoaded(true);
            });
        } else {
          setCountry(data.country);
          setRegion(regionNames.of(data.country.toUpperCase()));
          setCity(decodedCity);
          setIsLoaded(true);
        }
      })
      .catch(error => {
        console.error('Fetch error on local API:', error);
        setIsLoaded(true);
      });
  }, []);

  // Countdown timer logic
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  const formatTimeLeft = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}m ${seconds}s`;
  };

  return (
    <AnimatePresence>
      {isLoaded && (
        <motion.div 
          className="landing-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            initial={{ scale: 1.1 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              backgroundImage: 'url(https://ofmpics.com/clairee.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              zIndex: -1,
            }}
          />

          <motion.div 
            className="container"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.1, duration: 0.3 }}
          >
            <motion.img
              src="https://ofmpics.com/photo_2026-01-23_14-32-54-modified.png"
              alt="Header Image"
              className="header-image"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.3 }}
            />

            <motion.div 
              className="textContainer"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.3 }}
            >
              <section>
                <div className="username"><strong>claire🧚🏼</strong></div>
                <div className="useraccountname">@clairethompsonn</div>

                <div id="user-status" className="user-status">
                  <div className="status"></div>
                  <div id="available"><strong>Available now</strong></div>
                  <div className="separator"></div>
                  <div className="clock"></div>
                  <div className="respond-time"><strong>Responds in 2 minutes</strong></div>
                </div>
              </section>
            </motion.div>

            <motion.div 
              className="textContainer"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4, duration: 0.3 }}
            >
              <div className="location"></div>
              <span id="location-name"><strong>{city ? `${city} ${region}` : '<3'}</strong></span>
            </motion.div>

            <motion.div 
              className="textContainer2"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.3 }}
            >
              <div className="time-in-current-location">
                <strong>My name is Claire. I love to travel the world i'm looking for content partners in {city || 'your city'}. ❤️</strong>
              </div>
            </motion.div>

            <motion.div 
              className="textContainer3"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.3 }}
            >
              <motion.a 
                href="https://tapmy.social/clairethompsonn" 
                id="customButton"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Message Me Here
              </motion.a>
            </motion.div>

            <motion.div 
              className="countdown-block"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.7, duration: 0.3 }}
            >
              <span className="discount"><strong>35% OFF</strong></span>
              <span className="timer-end"><strong>ends in</strong> </span>
              <span id="timer"><strong>{formatTimeLeft(timeLeft)}</strong></span>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default HomePage;